import { z } from "zod";

/** Matches `RequestMasterTypeEnum` (currently only withdrawal). */
export enum RequestMasterTypeEnum {
    CONTRACT_WITHDRAWAL = 9,
}

export const RequestMasterTypeEnumSchema = z.nativeEnum(RequestMasterTypeEnum);
